import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

import InPageAlert from 'components/atoms/inPageAlert'

export const useStyles = makeStyles(theme => ({
  alertRoot: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  alertTitleText: {
    ...theme.typography.h6,
  },
}))

const PermissionErrorMessage = () => {
  const classes = useStyles()

  return (
    <InPageAlert
      title={"You don't have permission to view this content."}
// @ts-expect-error - TS2322 - Type '{ title: string; variant: string; icon: boolean; classes: ClassNameMap<"alertRoot" | "alertTitleText">; }' is not assignable to type 'IntrinsicAttributes & Props'.
      variant='outlined'
      icon={false}
      classes={classes}
    />
  )
}

export default PermissionErrorMessage
